export default {
  // for fantasy cricket
  PickWicketKeeper: 'Wicket Keepers',
  PickWicketKeeperMaxMessage: 'Select up to 4',
  PickBowler: 'Bowlers',
  PickBatsman: 'Batsman',
  PickWicketBatsmanMaxMessage: 'Select up to 6',
  PickAllRounder: 'All Rounders',
  WICKET_KEEPER: 'WICKET-KEEPER',
  BATSMEN: 'BATSMEN',
  ALL_ROUNDERS: 'ALL-ROUNDERS',
  BOWLERS: 'BOWLERS',
  MinimumBatsmanCricket: 'Please select minimum 3 Batsman',
  MinimumWKCricket: 'Please select minimum 1 Wicket Keeper',
  MinimumBowlerCricket: 'Please select minimum 3 Bowler',
  MinimumAllRounderCricket: 'Please select minimum 1 All-Rounder',
  MaximumBatsmanCricket: 'You can select maximum 6 Batsman',
  YouCanSelectMaximumBowler: 'You can select maximum 6 Bowlers',
  YouCanSelectMaximumAllRounder: 'You can select maximum 4 All-Rounders',
  YouCanSelectMaximumWK: 'You can select maximum 4 Wicket Keeper',
  MaxPlayersFromATeamCricket: 'Please select 11 Players',
  YouCanSelectMaxPlayersFromOneTeam: 'You can select maximum 7 players from the one team',
  PleaseSelectCaptain: 'Please select Captain',
  PleaseSelectViceCaptain: 'Please select Vice Captain',

  //for fantasy kabaddi
  FantasyKabaddi: 'Fantasy Kabaddi',
  PickDefenderKabaddi: 'Defender',
  PickDefenderMaxMessageKabaddi: 'Select up to 4',
  PickRaiderKabaddi: 'Raider',
  PickRaiderMaxMessageKabaddi: 'Select up to 3',
  PickAllRounderKabaddi: 'All Rounders',
  PickAllRounderMaxMessageKabaddi: 'Select up to 2',
  selectMinDefenderKabaddi: 'Please select minimum 2 Defender',
  selectMaxDefenderKabaddi: 'you can select maximum 4 Defender',
  selectMinRaiderKabaddi: 'Please select minimum 1 Raider',
  selectMaxRaiderKabaddi: 'you can select maximum 3 Raider',
  selectMinAllRounderKabaddi: 'Please select minimum 1 All Rounder',
  selectMaxAllRounderKabaddi: 'you can select maximum 2 All Rounder',
  YouCanSelectMaxPlayersFromOneTeamKabaddi: 'You can select maximum 5 players from the one team',
  MaxPlayersFromATeamKabaddi: 'Please select 7 Players',

  //for fantasy football
  PickGoalKeeper: 'Goal Keeper',
  PickDefender: 'Defender',
  PickForward: 'Forward',
  PickMidfielder: 'Midfielder',
  PickGoalKeeperMaxMessage: 'Select up to 1',
  PickDefenderMaxMessage: 'Select up to 5',
  PickForwardMaxMessage: 'Select up to 3',
  MinimumGKFootball: 'Please select minimum 1 Goal Keeper',
  YouCanSelectMaximumGK: 'You can select maximum 1 Goal Keeper',
  MinimumDefenderFootball: 'Please select minimum 3 Defender',
  MaximumDefenderFootball: 'You can select maximum 5 Defender',
  MinimumMidfielderFootball: 'Please select minimum 3 Midfielder',
  YouCanSelectMaximumMidfielder: 'Please Select maximum 5 Midfielder',
  MinimumForwardFootball: 'Please select minimum 1 Forward',
  YouCanSelectMaximumForward: 'Please select maximum 3 Forward',
  MaxPlayersFromATeamFootball: 'Please select 11 Players'
};
